import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
	children: any;
}

const Portal: React.FC<Props> = ({ children }): JSX.Element => {
	const popups: any = document.getElementById('widget');

	return createPortal(children, popups);
};

export { Portal };
